export const TOGGLE_CLASS_NAME_EDITOR_MODAL = 'LAB.CLASS.TOGGLE_CLASS_NAME_EDITOR_MODAL';
export const TOGGLE_ARCHIVATE_CLASS_MODAL = 'LAB.CLASS.TOGGLE_ARCHIVATE_CLASS_MODAL';

export const FINISH_CLASS_CREATION = 'LAB.CLASS.FINISH_CLASS_CREATION';
export const SET_SHOULD_REDIRECT = 'LAB.CLASS.SET_SHOULD_REDIRECT';
export const HANDLE_REDIRECT_TO_CREATED_CLASS = 'LAB.CLASS.HANDLE_REDIRECT_TO_CREATED_CLASS';

export const SET_CLASS_ID_TO_DELETE = 'LAB.CLASS.SET_CLASS_ID_TO_DELETE';
export const SET_CLASS_ITEM_TO_ARCHIVE = 'LAB.CLASS.SET_CLASS_ITEM_TO_ARCHIVE';

export const START_ADDING_NEW_STUDENTS_LIST = 'LAB.CLASS.START_ADDING_NEW_STUDENTS_LIST';
